"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeFromWin1251 = decodeFromWin1251;
exports.escapePdaString = escapePdaString;
exports.encodePdaJson = encodePdaJson;
exports.encodeToWin1251 = encodeToWin1251;
// Manual Win1251 Decoder for React Native (Hermes) where TextDecoder is missing
// Mappings based on standard Windows-1251 reference
const WIN1251_MAP = {
    128: 1026, 129: 1027, 130: 8218, 131: 1107, 132: 8222, 133: 8230, 134: 8224, 135: 8225,
    136: 8364, 137: 8240, 138: 1033, 139: 8249, 140: 1034, 141: 1036, 142: 1035, 143: 1039,
    144: 1106, 145: 8216, 146: 8217, 147: 8220, 148: 8221, 149: 8226, 150: 8211, 151: 8212,
    152: 152, 153: 8482, 154: 1109, 155: 8250, 156: 1110, 157: 1114, 158: 1113, 159: 1119,
    160: 160, 161: 1038, 162: 1118, 163: 1032, 164: 164, 165: 1168, 166: 166, 167: 167,
    168: 1025, 169: 169, 170: 1028, 171: 171, 172: 172, 173: 173, 174: 174, 175: 1031,
    176: 176, 177: 177, 178: 1030, 179: 1110, 180: 1169, 181: 181, 182: 182, 183: 183,
    184: 1105, 185: 8470, 186: 1108, 187: 187, 188: 1112, 189: 1029, 190: 1109, 191: 1111
};
function decodeFromWin1251(data) {
    let uint8;
    if (typeof Buffer !== 'undefined' && Buffer.isBuffer(data)) {
        uint8 = new Uint8Array(data);
    }
    else if (data instanceof ArrayBuffer) {
        uint8 = new Uint8Array(data);
    }
    else {
        uint8 = data;
    }
    let res = '';
    for (let i = 0; i < uint8.length; i++) {
        const code = uint8[i];
        if (code < 128) {
            res += String.fromCharCode(code);
        }
        else {
            if (code >= 192 && code <= 255) {
                // Cyrillic range
                res += String.fromCharCode(code - 192 + 1040);
            }
            else if (WIN1251_MAP[code]) {
                res += String.fromCharCode(WIN1251_MAP[code]);
            }
            else {
                // Extended punctuation or unknown, simpler fallback to standard if possible
                // Win1251 has specific chars in 128-191 range. 
                // Detailed mapping would be better but for MVP simple Cyrillic is key.
                // Todo: Full map if needed.
                res += '?';
            }
        }
    }
    return res;
}
// Build reverse map: Unicode codepoint → Win1251 byte
const UNICODE_TO_WIN1251 = {};
function isWin1251Char(code) {
    return code < 128 || UNICODE_TO_WIN1251[code] !== undefined;
}
/**
 * Escape characters that Win-1251 cannot represent as PDA numeric entities (&#12345;),
 * matching Android C0179y string serialization.
 */
function escapePdaString(str) {
    let result = '';
    for (let i = 0; i < str.length; i++) {
        const code = str.charCodeAt(i);
        if (code >= 0xd800 && code <= 0xdbff && i + 1 < str.length) {
            const low = str.charCodeAt(i + 1);
            if (low >= 0xdc00 && low <= 0xdfff) {
                const cp = (code - 0xd800) * 0x400 + (low - 0xdc00) + 0x10000;
                result += `&#${cp};`;
                i++;
                continue;
            }
        }
        if (isWin1251Char(code)) {
            result += str[i];
        }
        else {
            result += `&#${code};`;
        }
    }
    return result;
}
function pdaJsonReplacer(_key, value) {
    if (typeof value === 'string') {
        return escapePdaString(value);
    }
    return value;
}
/** JSON payload for PDA wire protocol: escape non-Win1251 text, then encode. */
function encodePdaJson(payload) {
    return encodeToWin1251(JSON.stringify(payload, pdaJsonReplacer));
}
// Populate from WIN1251_MAP (byte→unicode) → reverse (unicode→byte)
for (const [byteStr, unicode] of Object.entries(WIN1251_MAP)) {
    UNICODE_TO_WIN1251[unicode] = Number(byteStr);
}
// Cyrillic А-я (192-255 → U+0410-U+044F)
for (let i = 0; i <= 63; i++) {
    UNICODE_TO_WIN1251[1040 + i] = 192 + i;
}
// Ё/ё already in WIN1251_MAP (168→1025, 184→1105)
function encodeToWin1251(str) {
    const result = new Uint8Array(str.length);
    for (let i = 0; i < str.length; i++) {
        const charCode = str.charCodeAt(i);
        if (charCode < 128) {
            // ASCII
            result[i] = charCode;
        }
        else if (isWin1251Char(charCode)) {
            result[i] = UNICODE_TO_WIN1251[charCode];
        }
        else {
            // Character doesn't exist in Win-1251
            result[i] = 63; // '?'
        }
    }
    return result;
}
